document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.announcement-track');
  if (track) {
    track.innerHTML += track.innerHTML; // Duplicate for seamless loop
  }
});
